import type { AxonEvent } from '@reflex/shared';
import { StreamCardBubble } from './StreamCardBubble';
export function EventBubble({ event }: { event: AxonEvent }) {
  const payload = event.payload;
  const message =
    payload && typeof payload === 'object' && 'message' in payload
      ? String((payload as { message?: unknown }).message ?? '')
      : '';
  return (
    <StreamCardBubble title={event.type} timestamp={event.timestamp} event={event}>
      {message ? <p className="text-sm">{message}</p> : null}
    </StreamCardBubble>
  );
}
